module.exports = "<div> <h2 compile=data.title></h2> <div compile=data.description></div> <div compile=data.$$html></div> <bib-multimedia-section data=data2 ng-repeat=\"data2 in data.contents\"></bib-multimedia-section> </div>";


//////////////////
// WEBPACK FOOTER
// ./web/js/module/bibMultimediaSection/bibMultimediaSection.html
// module id = 1086
// module chunks = 0